import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './Stage.scss';

const StageItem = ({width, active, children}) => (
    <div style={{width}} className={classNames('item', 'btn', active ? 'btn-success' : 'btn-primary')}>
        {children}
    </div>
);

StageItem.propTypes = {
    width: PropTypes.string,
    active: PropTypes.bool,
    children: PropTypes.node,
};

StageItem.defaultProps = {
    active: false,
};

export default StageItem;
